import { type UseQueryResult, useQuery } from 'react-query';
import { FairMarketValueConfigurationService } from '../../services/wealthlane-award-services';

const useGetFmvConfigFmvType = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string | number;
    }>
  | undefined,
  unknown
> => {
  const fmvConfigFmvType = useQuery(
    ['getFmvConfigFmvType'],
    async () => {
      return await handleRequest(
        FairMarketValueConfigurationService.getApiAwardApiAppFairMarketValueConfigurationFmvTypesForFmvConfiguration()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.displayName ?? '',
            value: item.id ?? '',
            systemName: item.systemName ?? '',
          };
        });
      },
    }
  );

  return fmvConfigFmvType;
};

export default useGetFmvConfigFmvType;
